import { NavLink } from 'react-router-dom';
import { dashboardNavItems } from '@/components/feature/navItems';
import { BrandMark } from '@/components/feature/BrandLogo';
import { laundryProfile } from '@/mocks/dashboard';

interface DashboardSidebarProps {
  collapsed: boolean;
  onToggleCollapse: () => void;
  mobileOpen: boolean;
  onCloseMobile: () => void;
}

export default function DashboardSidebar({
  collapsed,
  onToggleCollapse,
  mobileOpen,
  onCloseMobile,
}: DashboardSidebarProps) {
  return (
    <>
      {mobileOpen && (
        <div
          className="fixed inset-0 z-40 bg-foreground-950/50 lg:hidden"
          onClick={onCloseMobile}
          aria-hidden="true"
        ></div>
      )}

      <aside
        className={[
          'fixed inset-y-0 right-0 z-50 flex flex-col bg-primary-700 transition-all duration-300',
          collapsed ? 'lg:w-[72px]' : 'lg:w-[260px]',
          'w-[260px]',
          mobileOpen ? 'translate-x-0' : 'translate-x-full lg:translate-x-0',
        ].join(' ')}
      >
        <div
          className={[
            'flex h-16 shrink-0 items-center gap-3 border-b border-white/10 px-4',
            collapsed ? 'lg:justify-center lg:px-0' : '',
          ].join(' ')}
        >
          <BrandMark size={34} className="shrink-0" />
          <div className={['min-w-0', collapsed ? 'lg:hidden' : ''].join(' ')}>
            <p className="truncate font-bold text-[15px] leading-tight text-white">Drop Clean</p>
            <p className="truncate text-[12px] text-secondary-200">{laundryProfile.name}</p>
          </div>
          <button
            type="button"
            onClick={onCloseMobile}
            className="ms-auto flex h-8 w-8 items-center justify-center rounded-md text-white/70 hover:bg-white/10 lg:hidden"
            aria-label="إغلاق القائمة"
          >
            <i className="ri-close-line text-lg" aria-hidden="true"></i>
          </button>
        </div>

        <nav className="flex-1 overflow-y-auto px-3 py-4">
          <ul className="space-y-1">
            {dashboardNavItems.map((item) => (
              <li key={item.path}>
                <NavLink
                  to={item.path}
                  title={collapsed ? item.label : undefined}
                  onClick={onCloseMobile}
                  className={({ isActive }) =>
                    [
                      'flex items-center gap-3 rounded-lg py-2.5 text-sm font-medium transition-colors',
                      collapsed ? 'lg:justify-center lg:px-0' : '',
                      'px-3',
                      isActive
                        ? 'border-e-[3px] border-accent-500 bg-white/10 text-white'
                        : 'border-e-[3px] border-transparent text-white/70 hover:bg-white/5 hover:text-white',
                    ].join(' ')
                  }
                >
                  <span className="flex h-5 w-5 shrink-0 items-center justify-center">
                    <i className={`${item.icon} text-[19px] leading-none`} aria-hidden="true"></i>
                  </span>
                  <span className={['truncate', collapsed ? 'lg:hidden' : ''].join(' ')}>
                    {item.label}
                  </span>
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>

        <div className="shrink-0 border-t border-white/10 p-3">
          <button
            type="button"
            className={[
              'flex w-full items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium text-danger-100 transition-colors hover:bg-danger-500/20 hover:text-white',
              collapsed ? 'lg:justify-center lg:px-0' : '',
            ].join(' ')}
            title={collapsed ? 'تسجيل الخروج' : undefined}
          >
            <span className="flex h-5 w-5 shrink-0 items-center justify-center">
              <i className="ri-logout-box-r-line text-[19px] leading-none text-danger-500" aria-hidden="true"></i>
            </span>
            <span className={['truncate', collapsed ? 'lg:hidden' : ''].join(' ')}>
              تسجيل الخروج
            </span>
          </button>

          <button
            type="button"
            onClick={onToggleCollapse}
            className="mt-1 hidden w-full items-center gap-3 rounded-lg px-3 py-2 text-[13px] text-white/50 transition-colors hover:bg-white/5 hover:text-white lg:flex lg:justify-center"
            aria-label={collapsed ? 'توسيع القائمة' : 'طي القائمة'}
          >
            <i
              className={collapsed ? 'ri-arrow-left-double-line text-lg' : 'ri-arrow-right-double-line text-lg'}
              aria-hidden="true"
            ></i>
            <span className={collapsed ? 'lg:hidden' : ''}>طي القائمة</span>
          </button>
        </div>
      </aside>
    </>
  );
}